import styled from "styled-components";
import { breakpoints, maxWidth } from "../../../styles/variables/breakpoints";
import { colors } from "../../../styles/variables/colors";

interface TableContainerProps {
  backgroundColor?: string;
  padding?: string;
}

export const bgColor = "#F6F7F7";

export const TableRowItem = styled.div`
  width: 33%;
`;

export const TableHeaderTitle = styled.h3`
  margin: 0;
  font-size: 21px;
  line-height: 26px;
  text-transform: uppercase;
  ${maxWidth(breakpoints.lg)} {
    font-size: 18px;
    line-height: 21px;
  }
  ${maxWidth(breakpoints.md)} {
    font-size: 16px;
    line-height: 18px;
  }
  ${maxWidth(breakpoints.sm)} {
    font-size: 10px;
    line-height: 12px;
  }
`;

export const TableContainer = styled.div<TableContainerProps>`
  padding: ${props => (props.padding ? props.padding : "4rem 10rem")};
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : "#fff"};
  ${maxWidth(breakpoints.lg)} {
    padding: 2rem;
  }
  ${maxWidth(breakpoints.sm)} {
    padding: 0.5rem 0rem;
    background-color: white;
  }
`;

export const TableAddress = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.infoAddress};
  padding: 0 0.5rem;
  ${maxWidth(breakpoints.md)} {
    font-size: 14px;
    line-height: 16px;
  }
  ${maxWidth(breakpoints.sm)} {
    font-size: 9px;
    line-height: 11px;
  }
`;

export const TableItemTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  line-height: 20px;
  ${maxWidth(breakpoints.md)} {
    font-size: 14px;
    line-height: 16px;
  }
  ${maxWidth(breakpoints.sm)} {
    font-size: 9px;
    line-height: 11px;
  }
`;

export const Table = styled.div`
  margin: 4rem 0 6rem;
`;
